import get from 'lodash/fp/get'

export const getActiveCategoryList = state => {
  const selectedCategory = get('slider.categoryListOpen')(state)

  return get(`categoriesLists.${selectedCategory}`)(state);
} 